import React from 'react'

const LampIdeaIcon = ({ className, size = 40, currentColor = "#EA580C" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 40 40`}
      fill={currentColor}>
      <path d="M19.9993 36.6673C19.2771 36.6673 18.6243 36.4937 18.041 36.1465C17.4577 35.7993 16.9993 35.334 16.666 34.7507C15.7493 34.7507 14.9646 34.4243 14.3118 33.7715C13.6591 33.1187 13.3327 32.334 13.3327 31.4173V25.5007C11.6938 24.4173 10.3813 22.9868 9.39518 21.209C8.40907 19.4312 7.91602 17.5007 7.91602 15.4173C7.91602 12.0562 9.08963 9.20204 11.4368 6.85482C13.7841 4.5076 16.6382 3.33398 19.9993 3.33398C23.3605 3.33398 26.2146 4.5076 28.5618 6.85482C30.9091 9.20204 32.0827 12.0562 32.0827 15.4173C32.0827 17.5562 31.5896 19.5007 30.6035 21.2507C29.6174 23.0007 28.3049 24.4173 26.666 25.5007V31.4173C26.666 32.334 26.3396 33.1187 25.6868 33.7715C25.0341 34.4243 24.2493 34.7507 23.3327 34.7507C22.9993 35.334 22.541 35.7993 21.9577 36.1465C21.3743 36.4937 20.7216 36.6673 19.9993 36.6673ZM16.666 31.4173H23.3327V29.9173H16.666V31.4173ZM16.666 28.2507H23.3327V26.6673H16.666V28.2507ZM21.2493 23.334V18.834L24.916 15.1673L23.166 13.4173L19.9993 16.584L16.8327 13.4173L15.0827 15.1673L18.7493 18.834V23.334H21.2493Z" fill={currentColor}/>
    </svg>
  )
}

export default LampIdeaIcon
